export type NotificacaoSirensDTO = {
    id: number,
    categoria: TipoCategoriaNotificacao,
    tipoNotificacao: String,

    conteudo: String,
    situacao: TipoSituacaoNotificacao;
   
    codigoSuporte: String,
    uuidEmpresa: String,
    uuidUsuario: String    
}

export enum TipoCategoriaNotificacao {
    ERRO = "ERRO",
    PENDENCIA = "PENDENCIA",
    INFORMATIVO = "INFORMATIVO"
    
}

export enum TipoSituacaoNotificacao {
    ATIVA = "ATIVA",
    REENVIADA = "REENVIADA",
    RESOLVIDA = "RESOLVIDA",
    EXCLUIDA = "EXCLUIDA"
}

export enum TipoConteudo {
    notificacao_conteudo_PENDENCIA_UNIDADE = "notificacao_conteudo_PENDENCIA_UNIDADE",
    notificacao_conteudo_PENDENCIA_CONDOMINIO = "notificacao_conteudo_PENDENCIA_CONDOMINIO",
    notificacao_conteudo_PENDENCIA_ADMINISTRADORA = "notificacao_conteudo_PENDENCIA_ADMINISTRADORA",
    notificacao_conteudo_PENDENCIA_CONTA_PRINCIPAL = "notificacao_conteudo_PENDENCIA_CONTA_PRINCIPAL",
    notificacao_conteudo_PENDENCIA_REMESSA = "notificacao_conteudo_PENDENCIA_REMESSA",
    notificacao_conteudo_PENDENCIA_CONTA_GROUP = "notificacao_conteudo_PENDENCIA_CONTA_GROUP",
    notificacao_conteudo_PENDENCIA_CLIENTE_GROUP = "notificacao_conteudo_PENDENCIA_CLIENTE_GROUP",
    notificacao_conteudo_PENDENCIA_BORDERO = "notificacao_conteudo_PENDENCIA_BORDERO",
    notificacao_conteudo_PENDENCIA_GED = "notificacao_conteudo_PENDENCIA_GED",
    notificacao_conteudo_ERRO_REABERTURA_PERIODO = "notificacao_conteudo_ERRO_REABERTURA_PERIODO",
    notificacao_conteudo_ERRO_CONTA_GROUP = "notificacao_conteudo_ERRO_CONTA_GROUP"
}